<div class="page-header-banner"><h1>Edit Website Page</h1></div>
<div class="container-fluid">
    <div class="row">
        <div class="col-12">

<!--        <div class="row wrapper border-bottom white-bg page-heading">-->
<!--            <div class="col-lg-10">-->
<!--                <h2>Website pages</h2>-->
<!--                <ol class="breadcrumb">-->
<!--                    <li class="breadcrumb-item">-->
<!--                        <a routerLink="/dashboard">Home</a>-->
<!--                    </li>-->
<!--                    <li class="breadcrumb-item active">-->
<!--                        <a routerLink="/pages">Website pages</a>-->
<!--                    </li>-->
<!--                    <li class="breadcrumb-item active">-->
<!--                        <strong>Edit page</strong>-->
<!--                    </li>-->
<!--                </ol>-->
<!--            </div>-->
<!--            <div class="col-lg-2">-->
<!--            </div>-->
<!--        </div>-->


        <div class="tabs-container mt-4">
            <ul class="nav nav-tabs" role="tablist">
                <li><a class="nav-link" [ngClass]="{'active' : tab === 1}" (click)="setTab(1)"> Page overview</a></li>
                <li><a class="nav-link" [ngClass]="{'active' : tab === 2}" (click)="setTab(2)">Page content</a></li>
            </ul>
            <div class="tab-content">
                <div role="tabpanel" class="tab-pane" [ngClass]="{'active' : tab === 1}">
                    <div class="panel-body">

                            <div *ngIf="page" class="card shadow-sm">

                                <div class="card-body bg-white">
                                    <h3>Page Overview</h3>

                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Is this an external page?</label>
                                        <div class="col-sm-3">
                                            <select class="form-control bordered" [(ngModel)]="page.external">
                                                <option [ngValue]="1">Yes</option>
                                                <option [ngValue]="0">No</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Floating breadcrumb?</label>
                                        <div class="col-sm-3">
                                            <select class="form-control bordered" [(ngModel)]="page.floatingBreadcrumb">
                                                <option [ngValue]="1">Yes</option>
                                                <option [ngValue]="0">No</option>
                                            </select>
                                        </div>
                                    </div>


                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">
                                            <span  *ngIf="!page.external">Page name</span>
                                            <span *ngIf="page.external">Link name</span>
                                        </label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control bordered" [(ngModel)]="page.name" />
                                            <span class="form-text m-b-none">
                                        A friendly name to reference this page in the admin area
                                        </span>
                                        </div>
                                    </div>
                                    <div class="hr-line-dashed"></div>
                                    <div class="mb-3 row" *ngIf="page.external === 0">
                                        <label class="col-sm-3 col-form-label">Page URL</label>
                                        <div class="col-sm-9">
                                            <div class="input-group m-b">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">{{env.siteUrl}}</span>
                                                </div>
                                                <input type="text" class="form-control bordered" [(ngModel)]="page.route" disabled />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <a [href]="env.siteUrl + page.route" target="_blank">
                                                            <i class="fa fa-external-link-alt"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 row" *ngIf="page.external === 1">
                                        <label class="col-sm-3 col-form-label">External Page URL</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control bordered" [(ngModel)]="page.externalURL" />
                                            <span class="form-text m-b-none">
                                            Copy and paste the link of the website page you are linking to.
                                        </span>
                                        </div>
                                    </div>

                                </div>


                                <div class="data-container m-0 mt-3">
                                    <h3>Hero Banner</h3>
                                    <p>If this page requires a full width hero banner you can upload the image and enter any text that is required</p>
                                    <div class="row">
                                        <div class="col-6">
                                            <input type="text" class="form-control bordered" [(ngModel)]="page.introTitle" placeholder="Enter banner title" />
                                            <textarea class="form-control bordered" rows="8" [(ngModel)]="page.introText" placeholder="Enter banner text"></textarea>
<!--                                            <div class="intro" style="padding: 50px; border: 1px dashed #eee;">-->
<!--                                                <editor [(ngModel)]="page.intro" [apiKey]="this.env.tinymceApiKey" [init]="tinyInit"></editor>-->
<!--                                            </div>-->


                                        </div>
                                        <div class="col-6">
                                            <div class="col-12">
                                                <h5>Upload banner image?</h5>
                                                <div class="vendor-logo text-center">
                                                    <div style="position: relative">
                                                        <img *ngIf="!page.introBackground" src="/assets/images/no-image.png" class="img-fluid" style="max-height: 150px" />
                                                        <img *ngIf="page.introBackground" [src]="page.introBackground" class="img-fluid" style="max-height: 150px" />
                                                        <button *ngIf="page.introBackground" class="btn btn-danger btn-sm"
                                                                style="position: absolute; bottom: 0; right: 0"
                                                                (click)="deleteIntroBackground()">
                                                                <img src="assets/images/icon-trash.svg" class="page-trash">
                                                        </button>
                                                    </div>
                                                    <br />
                                                    <button class="btn btn-primary btn-block mt-2" (click)="viewImageLibrary('banner', 'pageIntro')">Update</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>



                                <div class="data-container m-0 mt-3">
                                    <h3>Menu Options</h3>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="mb-3 row">
                                                <label class="col-sm-6 col-form-label">Add link to footer?</label>
                                                <div class="col-sm-6">
                                                    <select class="form-control bordered" [(ngModel)]="page.qlFooter">
                                                        <option value="1">Yes</option>
                                                        <option value="0">No</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="mb-3 row">
                                                <label class="col-sm-6 col-form-label">Add link to quick links?</label>
                                                <div class="col-sm-6">
                                                    <select class="form-control bordered" [(ngModel)]="page.qlPlugin">
                                                        <option value="1">Yes</option>
                                                        <option value="0">No</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="mb-3 row">
                                                <label class="col-sm-6 col-form-label">How many tile spaces?</label>
                                                <div class="col-sm-6">
                                                    <select class="form-control bordered" [(ngModel)]="page.tileCols">
                                                        <option *ngFor="let c of cols" value="{{c.Id}}">{{c.name}}</option>
                                                    </select>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="col-6">
                                            <div class="col-12">
                                                <h5>Does this page require a menu image?</h5>
                                                <div class="vendor-logo text-center">
                                                    <div style="position: relative">
                                                        <img *ngIf="!page.tile" src="/assets/images/no-image.png" class="img-fluid" style="max-height: 150px" />
                                                        <img *ngIf="page.tile" [src]="page.tile" class="img-fluid" style="max-height: 150px" />
                                                        <button *ngIf="page.tile" class="btn btn-danger btn-sm"
                                                                style="position: absolute; bottom: 0; right: 0"
                                                                (click)="deleteTile()">
                                                            <i class="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                    <br />
                                                    <button class="btn btn-primary btn-block mt-2" (click)="viewImageLibrary('cms', 'pageTile')">Update</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <div class="data-container m-0 mt-3" *ngIf="!page.external">
                                    <h3>Search Engine Optimisation</h3>
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Page meta title</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control bordered" [(ngModel)]="page.metaTitle" />
                                            <span class="form-text m-b-none">
                                                A block of help text that breaks onto a new line and may extend beyond one line.
                                            </span>
                                        </div>
                                    </div>
                                    <div class="hr-line-dashed"></div>
                                    <div class="mb-3 row">
                                        <label class="col-sm-3 col-form-label">Meta description</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control bordered" [(ngModel)]="page.metaDescription" />
                                            <span class="form-text m-b-none">
                                            Enter the page description. This will appear in Google search results.
                                        </span>
                                        </div>
                                    </div>
                                    <div class="hr-line-dashed"></div>

                                </div>






                            </div>
                        </div>
                </div>
                <div role="tabpanel" class="tab-pane" [ngClass]="{'active' : tab === 2}">
                    <div class="panel-body">

                        <div class="data-container m-0">
                            <button *ngIf="snippets.length > 1" class="btn btn-primary me-2" (click)="sortSnippets()">Sort content</button>
                            <button class="btn btn-primary me-2" (click)="addSnippet()">Add section</button>

                            <div class="webPage">
                                <div *ngFor="let snippet of snippets">
                                    <app-snippet-plugin *ngIf="snippet.type === 'plugin'" (action)="getPage()" [snippet]="snippet"></app-snippet-plugin>
                                    <app-snippet-gallery *ngIf="snippet.type === 'gallery'" (action)="getPage()" [snippet]="snippet"></app-snippet-gallery>
                                    <app-snippet-image *ngIf="snippet.type === 'image'" (action)="getPage()" [snippet]="snippet"></app-snippet-image>
                                    <app-snippet-grid *ngIf="snippet.type === 'grid'" (action)="getPage()" [snippet]="snippet"></app-snippet-grid>
                                    <app-snippet-wysiwyg *ngIf="snippet.type === 'wysiwyg'" (action)="getPage()" [snippet]="snippet"></app-snippet-wysiwyg>
                                    <app-snippet-video *ngIf="snippet.type === 'video'" (action)="getPage()" [snippet]="snippet"></app-snippet-video>
                                    <app-snippet-call-to-action *ngIf="snippet.type === 'c2a'" (action)="getPage()" [snippet]="snippet"></app-snippet-call-to-action>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="text-end">
                <button class="btn btn-primary" (click)="save()">Save</button>
            </div>


        </div>
        </div>
    </div>

</div>

<app-snippet-sortation [snippets]="snippets" (modalAction)="sortModalAction($event)" *ngIf="snippetSortModal"></app-snippet-sortation>
<app-snippet-add [page]="page" (modalAction)="addModalAction($event)" *ngIf="snippetAddModal"></app-snippet-add>
<app-images *ngIf="showImageLibrary && page" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="libraryModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>
